import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaLaptop,
  FaTshirt,
  FaHome,
  FaSpa,
  FaShoppingBasket,
  FaGamepad,
  FaRunning,
  FaBook,
  FaMobileAlt,
  FaTv,
  FaGem,
  FaCouch,
  FaPalette,
  FaCarrot,
  FaPuzzlePiece,
  FaBasketballBall,
  FaSearch,
  FaShoppingCart,
} from 'react-icons/fa';
import '../styles/Home.css';
import HeroVideo from '../assets/video/Hero.mp4';

const Home = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [products] = useState([
    {
      id: 1,
      name: 'Galaxy S22 Ultra',
      price: '129999',
      old: '279999',
      img: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?auto=format&fit=crop&w=1000&q=80',
    },
    {
      id: 2,
      name: 'Galaxy M33 (4GB | 64GB)',
      price: '169999',
      old: '249999',
      img: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=1000&q=80',
    },
    {
      id: 3,
      name: 'iPhone 14 Pro',
      price: '199999',
      old: '249999',
      img: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?auto=format&fit=crop&w=1000&q=80',
    },
    {
      id: 4,
      name: 'Samsung Tablet S8',
      price: '89999',
      old: '119999',
      img: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=1000&q=80',
    },
    {
      id: 5,
      name: 'MacBook Pro M2',
      price: '299999',
      old: '349999',
      img: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=1000&q=80',
    },
  ]);

  const navigate = useNavigate();

  useEffect(() => {
    console.log('Home component loaded');
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      alert(`Searching for: ${searchQuery}`);
    }
  };

  const handleProductCardClick = (category) => {
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  const handleServiceCardClick = (service) => {
    navigate(service);
  };

  const handleAddToCart = (productName, e) => {
    e.stopPropagation();
    alert(`Added ${productName} to cart`);
  };

  const handleViewDetails = (productId, e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/view/${productId}`);
  };

  const handleDealCardClick = (productId, e) => {
    if (!e.target.closest('.add-to-cart')) {
      navigate(`/view/${productId}`);
    }
  };

  const productCategories = [
    { icon: FaLaptop, name: 'Electronics' },
    { icon: FaTshirt, name: 'Fashion' },
    { icon: FaHome, name: 'Home' },
    { icon: FaSpa, name: 'Beauty' },
    { icon: FaShoppingBasket, name: 'Grocery' },
    { icon: FaGamepad, name: 'Toys' },
    { icon: FaRunning, name: 'Sports' },
    { icon: FaBook, name: 'Books' },
    { icon: FaMobileAlt, name: 'Phones' },
    { icon: FaTv, name: 'TV & Audio' },
    { icon: FaGem, name: 'Jewelry' },
    { icon: FaCouch, name: 'Furniture' },
    { icon: FaPalette, name: 'Art' },
    { icon: FaCarrot, name: 'Food' },
    { icon: FaPuzzlePiece, name: 'Games' },
    { icon: FaBasketballBall, name: 'Fitness' },
  ];

  const services = [
    {
      name: 'Product',
      path: '/products',
      image:
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=500&q=80',
    },
    {
      name: 'Service',
      path: '/service',
      image:
        'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&w=500&q=80',
    },
    {
      name: 'Job Portal',
      path: '/job',
      image:
        'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=500&q=80',
    },
  ];

  const bannerImages = [
    'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=1600&q=80',
  ];

  const handleKeyPress = (e, callback, ...args) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback(...args);
    }
  };

  return (
    <div className='home'>
      {/* Hero Section */}
      <section className='hero'>
        <video autoPlay muted loop playsInline className='hero-video'>
          <source src={HeroVideo} type='video/mp4' />
          Your browser does not support the video tag.
        </video>

        <div className='hero-content'>
          <h1>Enjoy Unlimited Reach with Fahple</h1>
          <p>Advertise anything - Reach Everyone that matters</p>
          <form className='search-bar' onSubmit={handleSearch}>
            <input
              type='text'
              placeholder='What are you looking for this time'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type='submit'>
              <FaSearch />
            </button>
          </form>
        </div>
      </section>

      {/* Products Row */}
      <section className='products-section'>
        <div className='products-row-wrapper'>
          <div className='products-row'>
            {productCategories.map((category, index) => {
              const IconComponent = category.icon;
              return (
                <div
                  key={index}
                  className='product-card'
                  onClick={() => handleProductCardClick(category.name)}
                  onKeyDown={(e) =>
                    handleKeyPress(e, handleProductCardClick, category.name)
                  }
                  tabIndex='0'
                  role='button'
                  aria-label={`Browse ${category.name} category`}
                >
                  <IconComponent className='product-icon' />
                  <span className='product-name'>{category.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Our Services */}
      <section className='services'>
        <h2>Our Services</h2>
        <div className='services-container'>
          {services.map((service, index) => (
            <div
              key={index}
              className='service-card'
              onClick={() => handleServiceCardClick(service.path)}
              onKeyDown={(e) =>
                handleKeyPress(e, handleServiceCardClick, service.path)
              }
              tabIndex='0'
              role='button'
              aria-label={`Navigate to ${service.name}`}
            >
              <img src={service.image} alt={service.name} loading='lazy' />
              <h3>{service.name}</h3>
            </div>
          ))}

          <div className='service-card dark'>
            <div className='slideshow'>
              <img
                src='https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80'
                alt='Business meeting'
              />
              <img
                src='https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80'
                alt='Team collaboration'
              />
              <img
                src='https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=800&q=80'
                alt='Success celebration'
              />
            </div>
          </div>
        </div>
      </section>

      {/* Banner */}
      <section className='banner'>
        <div className='slideshow'>
          {bannerImages.map((image, index) => (
            <img key={index} src={image} alt={`Banner ${index + 1}`} />
          ))}
        </div>
      </section>

      {/* Hot Deals */}
      <section className='deals-section'>
        <h2 className='deals-title'>Hot Deals</h2>
        <div className='deals-container'>
          {products.map((product) => (
            <div
              key={product.id}
              className='deal-card'
              onClick={(e) => handleDealCardClick(product.id, e)}
              onKeyDown={(e) =>
                handleKeyPress(e, handleDealCardClick, product.id, e)
              }
              tabIndex='0'
              role='button'
              aria-label={`View details for ${product.name}`}
            >
              <div className='offer'>Best Deal</div>
              <img src={product.img} alt={product.name} />

              <p className='product-title'>{product.name}</p>

              <p className='price'>
                LKR {parseInt(product.price).toLocaleString()}
                <span className='old-price'>
                  LKR {parseInt(product.old).toLocaleString()}
                </span>
              </p>

              <p className='save'>
                Save - LKR{' '}
                {(
                  parseInt(product.old) - parseInt(product.price)
                ).toLocaleString()}
              </p>

              <button
                className='add-to-cart'
                onClick={(e) => handleAddToCart(product.name, e)}
              >
                <FaShoppingCart className='cart-icon' /> Add to Cart
              </button>

              <button
                className='view-btn'
                onClick={(e) => handleViewDetails(product.id, e)}
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
